/**
 * "Clear filters" button for list-page filter bars. Renders nothing unless
 * a filter is actually active, so it only shows up when there's something
 * to clear.
 */
export default function ClearFiltersButton({ active, onClear }) {
  if (!active) return null;
  return (
    <button type="button" className="btn btn-ghost btn-sm" onClick={onClear}>
      Clear filters
    </button>
  );
}

export const EMPTY_PERIOD = { preset: 'all', from: '', to: '' };
